module.exports = __webpack_public_path__ + "static/media/IconTemplates_-44.e2874b5b.svg";